import React from 'react';
import './Pagination.css'; // Ensure you import the CSS with global styles

interface PaginationProps {
    page: number;
    totalPages: number;
    size: number;
    onPageChange: (newPage: number) => void;
    onSizeChange: (newSize: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ page, totalPages, size, onPageChange, onSizeChange }) => {
    return (
        <div className="pagination">
            <button onClick={() => onPageChange(Math.max(page - 1, 0))} disabled={page === 0}>
                ⬅ Previous
            </button>
            <span>Page {page + 1} of {totalPages}</span>
            <button onClick={() => onPageChange(Math.min(page + 1, totalPages - 1))} disabled={page >= totalPages - 1}>
                Next ➡
            </button>
            <select value={size} onChange={(e) => onSizeChange(Number(e.target.value))}>
                {[5, 10, 25, 50].map(n => (
                    <option key={n} value={n}>{n} per page</option>
                ))}
            </select>
        </div>
    );
};

export default Pagination;
